import { Send, ArrowBack } from '@mui/icons-material'
import { Box, Stack, Typography, Button } from '@mui/material'
import type React from 'react'

import type { Income } from '@/types/Activity'
import { RequestType } from '@/types/Recommendation'

import RequestForm from './RequestForm'
import type { SubjectData } from './types'

interface Props {
  activeRequestType: RequestType
  subjectData: SubjectData
  incomes: Income[]
  setViewMode: (mode: 'list' | 'form') => void
  setIsFormSubmitting: (submitting: boolean) => void
  handleRequestsUpdated: () => void
}

const RequestsFormView: React.FC<Props> = ({
  activeRequestType,
  subjectData,
  incomes,
  setViewMode,
  setIsFormSubmitting,
  handleRequestsUpdated,
}) => {
  return (
    <Box sx={{ p: 3, height: '100%', overflow: 'auto' }}>
      <Stack spacing={3}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Button
            startIcon={<ArrowBack />}
            onClick={() => setViewMode('list')}
            sx={{
              color: '#9b006a',
              textTransform: 'none',
              fontSize: '14px',
              fontWeight: 500,
              p: 0,
              minWidth: 'auto',
            }}
          >
            Back to requests
          </Button>
        </Box>

        <Box>
          <Stack direction="row" spacing={1.25} alignItems="center">
            <Send sx={{ fontSize: 32, color: '#1B4554' }} />
            <Typography variant="h5" sx={{ fontWeight: 600 }}>
              {activeRequestType === RequestType.PAYROLL
                ? 'Payroll/HMRC Request'
                : 'Open Banking Request'}
            </Typography>
          </Stack>
          <Typography
            variant="body2"
            sx={{
              mt: 1,
              letterSpacing: '0.14px',
              color: 'text.secondary',
            }}
          >
            {activeRequestType === RequestType.PAYROLL
              ? 'Send the applicant an email asking them to connect their payroll provider through Konfir. This helps verify their income details.'
              : 'Send the applicant an email asking them to connect their bank account. This helps verify their income and financial details.'}
          </Typography>
        </Box>

        <RequestForm
          subjectData={subjectData}
          requestType={activeRequestType}
          incomes={incomes}
          onSubmitStart={() => setIsFormSubmitting(true)}
          onSubmitEnd={() => setIsFormSubmitting(false)}
          onSuccess={() => {
            handleRequestsUpdated()
            setViewMode('list')
          }}
          onError={() => {}}
        />
      </Stack>
    </Box>
  )
}

export default RequestsFormView
